import { render, staticRenderFns } from "./InstagramSubscription.vue?vue&type=template&id=4a385801"
import script from "./InstagramSubscription.vue?vue&type=script&lang=js"
export * from "./InstagramSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports